import { render, staticRenderFns } from "./NotificationCollectionCentreApprovalRequest.vue?vue&type=template&id=4f563c08"
import script from "./NotificationCollectionCentreApprovalRequest.vue?vue&type=script&lang=js"
export * from "./NotificationCollectionCentreApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports